import React, { useEffect, type ReactNode } from "react";
import { useSession } from "@/lib/session";
import { useDispatch, useSelector } from "react-redux";
import { setTempLogin } from "@/store/slices/authSlice";
import { type RootState } from "@/store/store";
import { safeStorage } from "@/shared/lib/safeStorage";

interface AuthProviderProps {
  children: ReactNode;
}

export default function AuthProvider({ children }: AuthProviderProps) {
  useSession();
  const dispatch = useDispatch();
  const tempLogin = useSelector((state: RootState) => state.auth.tempLogin);

  // Initialize auth state from localStorage on mount
  useEffect(() => {
    // Only run once on mount and if we don't already have tempLogin
    if (tempLogin) return;

    try {
      const storedUserDetails = safeStorage.getItem("userDetails");
      if (storedUserDetails) {
        const userDetails = JSON.parse(storedUserDetails);

        // If we have stored user details, set temp login for OTP flow
        if (userDetails.merchantId && userDetails.username) {
          dispatch(
            setTempLogin({
              merchantId: userDetails.merchantId,
              username: userDetails.username,
              emailId: userDetails.emailId,
              phoneNumber: userDetails.phoneNumber,
            })
          );
        }
      }
    } catch (error) {
      console.error("Failed to parse stored user details:", error);
      // Clear invalid localStorage data
      safeStorage.removeItem("userDetails");
    }
  }, [dispatch, tempLogin]);

  return <>{children}</>;
}
